module.exports = __webpack_public_path__ + "img/writing.ac4499dd.png";